/**
 * Kích thước dùng cho 発送依頼.
 *
 * - Item ĐÃ lưu kho: 保管サイズ (storage*) — hành vi cũ, không đổi.
 * - Item CHƯA lưu kho (chưa 検品 chi tiết): fallback 到着時サイズ của storage request (real*, staff đo
 *   lúc nhập kho). Phí tính ra là TẠM TÍNH — admin chốt size thật ở bước 発送準備, chênh lệch được
 *   返金・差額徴収 ở kỳ billing.
 * - Chưa có cả hai (kiện chưa về / chưa đo): trả null -> không cho tạo yêu cầu.
 *
 * Giữ đúng khuôn số cũ: item có đủ 保管サイズ luôn đi nhánh đầu, không đụng tới real*.
 */
export type EffectiveDims = {
  length: number;
  width: number;
  height: number;
  weight: number;
  isFallback: boolean;
};

export const getEffectiveDims = (item: any): EffectiveDims | null => {
  if (!item) return null;

  const hasStorageSize = !!item.storageLength && !!item.storageWidth && !!item.storageHeight && !!item.storageWeight;
  if (hasStorageSize) {
    return {
      length: Number(item.storageLength),
      width: Number(item.storageWidth),
      height: Number(item.storageHeight),
      weight: Number(item.storageWeight),
      isFallback: false,
    };
  }

  const req = item.storageRequest;
  const hasArrivalSize = !!req?.realLength && !!req?.realWidth && !!req?.realHeight && !!req?.realWeight;
  if (hasArrivalSize) {
    return {
      length: Number(req.realLength),
      width: Number(req.realWidth),
      height: Number(req.realHeight),
      weight: Number(req.realWeight),
      isFallback: true,
    };
  }

  return null;
};

/** Một chiều cụ thể; trả 0 khi chưa đo được gì (giữ đúng kiểu `|| 0` mà code cũ dùng). */
export const effDim = (item: any, key: 'length' | 'width' | 'height' | 'weight'): number =>
  getEffectiveDims(item)?.[key] ?? 0;

/** Item có đo được kích thước để tạo 発送依頼 không (dù là 保管 hay 到着時). */
export const canResolveShipDims = (item: any): boolean => !!getEffectiveDims(item);

/** Item đang phải dùng 到着時サイズ -> phí hiển thị là 仮送料. */
export const isUsingArrivalSize = (item: any): boolean => !!getEffectiveDims(item)?.isFallback;
